<div class="modal-lg">
  <div class="modal-header" ngbAutoFocus>
    <h5 *ngIf="!modal.isError" class="modal-title text-warning d-flex align-items-center">
      <span class="icon-warning mr-2 ft-sz-24"></span>
      {{ 'BaseModal.Warning' | translate}}
    </h5>
    <h5 *ngIf="modal.isError" class="modal-title text-danger d-flex align-items-center">
      <span class="icon-error mr-2 ft-sz-24"></span>
      {{'BaseModal.Warning' | translate}}
    </h5>
    <button *ngIf="!modal.hideHeaderCloseButton" type="button" class="close pull-right" aria-label="Fechar" (click)="close()">
      <span aria-hidden="true" class="icon-close"></span>
    </button>
  </div>
  <div *ngIf="modal.isHtml" class="modal-body" style="white-space: pre-wrap;" [innerHtml]="modal.message">

  </div>
  <div *ngIf="!modal.isHtml" class="modal-body" style="white-space: pre-wrap;">
    {{modal.message | translate: modal.param}}
  </div>

  <div class="modal-footer">
    <button *ngIf="!modal.cancelButton?.hideButton" type="button" class="btn" [class]="cancelButtonClass" aria-label="Cancelar" (click)="decline()"><span [class]="cancelIcon"></span><span>{{cancelText}}</span></button>
    <button *ngIf="!modal.isError" type="button" class="btn btn-primary" aria-label="Continuar" (click)="confirm()"><span class="icon-check"></span><span>{{ (modal.confirmButton?.buttonText != null && modal.confirmButton?.buttonText != undefined ) ? modal.confirmButton?.buttonText : ('BaseModal.Continue' | translate)}}</span></button>
  </div>

</div>
